import b_ from "b_";
// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__aU7mg","backdrop":"styles_backdrop__JVGFn","visible":"styles_visible__vKs9Y","header":"styles_header__YN+6L","body":"styles_body__f-4Yp"};
export const b = b_.with('overlay');